<template>
  <div class="mobile-main-container position-relative">
    <div style="height: 46px; padding: 16px">
      <div class="d-flex align-center justify-space-between" style="width: 100%">
        <!--        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>-->
        <div @click="appBarMenuClick">
          <svg-icon style="height: 20px; width: 20px" icon-class="menu"></svg-icon>
        </div>
        <span class="d-inline-block text-truncate"
              style="font-weight: 500;font-size: 17px;text-align: center;color: #262626">{{ message }}</span>
        <div class="d-flex align-center">
          <!--          <feedback-menu></feedback-menu>-->
          <v-icon size="25" color="#3E4055" @click='openNewChat'>{{ icons.mdiChatPlusOutline }}</v-icon>
        </div>
      </div>
    </div>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      left
      temporary
      color='#FFFFFF'
      width='260'
    >
      <div class='position-relative' style='overflow: hidden; height: 100%;'>
        <div class="d-flex align-center justify-end">
          <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        </div>
        <div class="pl-4 cursor-pointer" @click="showChats = !showChats">
          <span style="font-size: 14px; font-weight: 600; color: #100d1b">Chats</span>
          <v-icon size="18"
                  :style="{transform: showChats ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.3s ease'}"
                  color="#100d1b">
            {{ icons.mdiChevronDown }}
          </v-icon>
        </div>
        <div v-if='showChats'
             class='position-relative'
             style='overflow-y: auto; height: calc(100% - 105px)'>
          <v-list class="pa-0" dense>
            <v-list-item v-for='(item, i) in chatSessionList'
                         :key='item.chatSessionId'
                         class="pa-0"
                         color="#fef9ff"
                         :style="{background: item.open ? '#fef9ff' : ''}"
                         @click="messageSearch(item);"
            >
              <van-swipe-cell style='height: 50px; width: 100%' :stop-propagation="true"
                              @open="swipeCellOperation(item, true)" @close="swipeCellOperation(item, false)">
              <span class="d-inline-block text-truncate"
                    style='color: #292834; font-size: 12px; margin-left: 12px; width: 90%'>
                {{ item.queryName }}
              </span>
                <template #right>
                  <van-button style="height: 50px; width: 50px" square color="#EEDCFD" @click='rename(item)'>
                    <svg-icon icon-class="edit"></svg-icon>
                  </van-button>
                  <van-button style="height: 50px; width: 50px" square color="#FD3B31" @click='deleteMsg(item)'>
                    <svg-icon icon-class="delete"></svg-icon>
                  </van-button>
                </template>
              </van-swipe-cell>
            </v-list-item>
            <!--            <div-->
            <!--              @mouseover='mouseover(item)'-->
            <!--              @mouseleave='mouseleave(item)'-->
            <!--              @click='messageSearch(item)'-->
            <!--              style='height: 45px; width: 100%'-->
            <!--              class="mb-1"-->
            <!--            >-->
            <!--              <div-->
            <!--                style='width: 100%; height: 100%'-->
            <!--                :class="['d-flex',-->
            <!--                  'align-center',-->
            <!--                  'cursor-pointer',-->
            <!--                  'justify-space-between',-->
            <!--                  item.chatSessionId === chatSessionId && !item.renameFlag ? 'selected-item' : '',-->
            <!--                  item.showOption && !item.renameFlag ? 'hover-item' : ''-->
            <!--                  ]"-->
            <!--              >-->
            <!--                <v-tooltip v-if='!item.renameFlag' top>-->
            <!--                  <template v-slot:activator='{ on, attrs }'>-->
            <!--                    <div style='width: 100%; padding: 0 10px' v-bind='attrs' v-on='on'-->
            <!--                         class='d-inline-block text-truncate'>-->
            <!--                          <span style='color: #292834; font-size: 12px'>-->
            <!--                            {{ item.queryName }}-->
            <!--                          </span>-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                  <span>{{ item.queryName }}</span>-->
            <!--                </v-tooltip>-->

            <!--                <div v-else style='width: 100%'>-->
            <!--                  <v-text-field-->
            <!--                    autofocus-->
            <!--                    style='width: 100%'-->
            <!--                    v-model='item.queryName'-->
            <!--                    outlined-->
            <!--                    dense-->
            <!--                    hide-details-->
            <!--                  ></v-text-field>-->
            <!--                </div>-->

            <!--                <v-menu-->
            <!--                  ref="menuRef"-->
            <!--                  bottom-->
            <!--                  left-->
            <!--                >-->
            <!--                  <template v-slot:activator='{ on, attrs }'>-->
            <!--                    <v-btn-->
            <!--                      v-show='!item.renameFlag'-->
            <!--                      fab-->
            <!--                      text-->
            <!--                      x-small-->
            <!--                      icon-->
            <!--                      v-bind='attrs'-->
            <!--                      v-on='on'-->
            <!--                      @click='mouseover(item)'-->
            <!--                    >-->
            <!--                      <v-icon small size='18' color='#5e5669ad'>-->
            <!--                        {{ icons.mdiDotsHorizontal }}-->
            <!--                      </v-icon>-->
            <!--                    </v-btn>-->

            <!--                  </template>-->
            <!--                  <v-list dense>-->
            <!--                    <v-list-item-->
            <!--                      link-->
            <!--                      @click='rename(item)'-->
            <!--                    >-->
            <!--                      <v-list-item-title>-->
            <!--                        <v-icon small size='20'>-->
            <!--                          {{ icons.mdiPencilOutline }}-->
            <!--                        </v-icon>-->
            <!--                        Rename-->
            <!--                      </v-list-item-title>-->
            <!--                    </v-list-item>-->
            <!--                    <v-list-item-->
            <!--                      link-->
            <!--                      @click='deleteMsg(item)'-->
            <!--                    >-->
            <!--                      <v-list-item-title>-->
            <!--                        <v-icon small size='20' color='#EF4444'>-->
            <!--                          {{ icons.mdiTrashCanOutline }}-->
            <!--                        </v-icon>-->
            <!--                        Delete-->
            <!--                      </v-list-item-title>-->
            <!--                    </v-list-item>-->
            <!--                  </v-list>-->
            <!--                </v-menu>-->
            <!--              </div>-->
            <!--            </div>-->
          </v-list>
        </div>
        <div v-if='!mini' class='d-flex align-center mt-2'
             style='height: 62px; width: 100%; position: absolute; bottom: 0; padding: 18px 20px;'>
          <v-btn
            class="start-new-chat"
            :height='28'
            color='#ffffff'
            @mouseenter="startNewChatMouseenter"
            @mouseleave="startNewChatMouseleave"
            depressed
            block
            @click='openNewChat'
          >
            <v-icon size='15' color='#FFFFFF'>
              {{ icons.mdiPlus }}
            </v-icon>
            <span style='font-size: 14px; color: #FFFFFF; font-weight: 600; margin-left: 8px'>新建对话</span>
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <div v-if="showDetailFlag" class="overflow-y-auto" style="height: 100%">
      <div ref='messageListContainer' class='chat-container fill-height'
           style='margin: 0 auto; position: relative; height: calc(100vh - 20px); overflow-y: auto; overflow-x: hidden; border: none'>
        <message-list
          ref="messageList"
          :language="systemLanguage"
          :messages='messages'
          :loading='loading'
          @scrollToBottom="scrollToBottom"
          @componentEventHandle="(data) => $emit('componentEventHandle', data)"
          @refreshAnswer="(data) => $emit('refreshAnswer', data)"
          @reservation="(data) => $emit('reservation', data)"
          @cancelBookingCompletedEmit="(data) => $emit('cancelBookingCompletedEmit', data)"
          @thinkingCompleted="$emit('thinkingCompleted')"
          @cancelChat="(val) => $emit('cancelChat', val)"
        ></message-list>
      </div>

      <div
        style='position: absolute; width: 100%; display: grid; place-items: center; bottom: 0; background: #ffffff'
      >
        <!--        <message-input-->
        <!--          :inputWidth='windowInnerWidth * 0.92'-->
        <!--          @sendMessage="sendMessage"-->
        <!--          :sendMessageLoading='sendMessageLoading'-->
        <!--        ></message-input>-->
        <chatInput
          :inputWidth="windowInnerWidth" @sendMessage='sendMessage'
        ></chatInput>
        <span class="mt-1" style='font-size: 12px; color: #a3a3a3; margin-bottom: 6px; text-align: center'>
          Copyright 2001-{{ new Date().getFullYear() }} © Accenture.All rights reserved.Accenture
          Confidential.For
          internal use only.
        </span>
      </div>
    </div>
    <home v-else @sendMessage="sendMessage"></home>
    <v-dialog
      v-model='deleteMsgDialog'
      persistent
      width='420'
    >
      <v-card>
        <v-card-title class="d-flex flex-column align-center justify-center"
                      style='font-size: 18px; color: #404040; font-weight: bold'>
          <img width="50px" :src="require('@/assets/images/icon-delete.png')">
          <div class="mt-2">删除对话</div>
        </v-card-title>
        <v-card-text class="d-flex align-center justify-center">

          <span style='font-size: 14px; color: #A6A7A9'>此操作不可撤回，对话将永久删除</span>
        </v-card-text>
        <v-card-actions class="d-flex justify-center mt-4">
          <v-btn
            color="#F2F2F7"
            class="rounded-pill elevation-0 mr-4"
            @click='deleteMsgDialog = false'
          >
            <span class="mx-2">取消</span>
          </v-btn>
          <v-btn
            class="rounded-pill elevation-0"
            :loading='deleteMagLoading'
            color='#A75CFF'
            @click='deleteQueryMessage'
          >
            <span class="mx-2" style='color: white'>确认删除</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model='editDialog'
      persistent
      width='420'
    >
      <v-card>
        <v-card-title class="d-flex flex-column align-center justify-center"
                      style='font-size: 18px; color: #404040; font-weight: bold'>
          <img width="50px" :src="require('@/assets/images/icon-edit.png')">
          <div class="mt-2">编辑对话名称</div>
        </v-card-title>
        <v-card-text class="d-flex align-center justify-center">
          <v-text-field
            autofocus
            style='width: 100%'
            v-model='currentItem.queryName'
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="d-flex justify-center mt-4">
          <v-btn
            color="#F2F2F7"
            class="rounded-pill elevation-0 mr-4"
            @click='editDialog = false'
          >
            <span class="mx-2">取消</span>
          </v-btn>
          <v-btn
            class="rounded-pill elevation-0"
            :loading='editLoading'
            color='#A75CFF'
            @click="renameBlur(currentItem)"
          >
            <span class="mx-2" style='color: white'>确认保存</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { deleteByChatSessionId, renameChatSession } from '@/modules/chat/api'
import { store } from '@/myops/core'
import { set_conversation_id } from '@/modules/chat/util/ChatBotUtil'
import { mapGetters } from 'vuex'
import chatInput from './component/chat-input'
import {
  mdiTrashCanOutline,
  mdiChatPlusOutline,
  mdiDotsHorizontal,
  mdiPencilMinusOutline,
  mdiMenuUp,
  mdiMenuDown,
  mdiPencilOutline,
  mdiPlus,
  mdiChevronRight,
  mdiChevronDown,
} from '@mdi/js'
import MessageList from '@/modules/chat/view/chatbot/component/MessageList.vue'
import MessageInput from '@/modules/chat/view/chatbot/component/MessageInput20250515.vue'
import Home from './component/home'
import FeedbackMenu from '@/modules/chat/view/chatbot/component/FeedbackMenu'

export default {
  components: {
    MessageList,
    MessageInput,
    Home,
    FeedbackMenu,
    chatInput,
  },
  props: {
    chatSessionList: {
      type: Array,
      default: () => [],
    },
    systemLanguage: {
      type: String,
      default: 'chinese',
    },
    messages: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isOpsSuperAdmin: {
      type: Boolean,
      default: false,
    },
    showDetailFlag: {
      type: Boolean,
      default: false,
    },
    sendMessageLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      chatSessionId: 'chat/chatSessionId',
      modelType: 'chat/modelType',
    }),
    windowInnerWidth() {
      return window.innerWidth
    },
  },
  data: () => ({
    drawer: false,
    mini: false,
    currentItem: { queryName: '' },
    editLoading: false,
    icons: {
      mdiTrashCanOutline,
      mdiChatPlusOutline,
      mdiDotsHorizontal,
      mdiPencilMinusOutline,
      mdiPencilOutline,
      mdiMenuUp,
      mdiMenuDown,
      mdiPlus,
      mdiChevronRight,
      mdiChevronDown,
    },
    editDialog: false,
    deleteMsgDialog: false,
    deleteMag: null,
    deleteMagLoading: false,
    eid: store.state.user.user.eid,
    personName: null,
    selectedChatItem: null,
    oldQueryName: '',
    startNewChatMouseenterFlag: false,
    showChats: true,
    group: null,
    animationIdList: [],
    message: '',
  }),
  methods: {
    swipeCellOperation(item, open) {
      const index = this.chatSessionList.findIndex(value => value.chatSessionId === item.chatSessionId)
      if (index !== -1) {
        this.$set(this.chatSessionList[index], 'open', open)
      }
    },
    sendMessage(msg) {
      this.message = msg
      this.$emit('sendMessage', msg)
    },
    scrollToBottom() {
      this.$nextTick(() => {
          const container = this.$refs.messageListContainer
          if (container.scrollTo) {
            // 使用requestAnimationFrame确保在渲染下一帧前执行
            const animationId = requestAnimationFrame(() => {
                container.scrollTo({
                  top: container.scrollHeight,
                  behavior: 'smooth', // 添加平滑滚动效果
                })
              },
            )
            this.animationIdList.push(animationId)
          }
        },
      )
    },
    startNewChatMouseenter() {
      this.startNewChatMouseenterFlag = true
    }
    ,
    startNewChatMouseleave() {
      this.startNewChatMouseenterFlag = false
    }
    ,
    async renameBlur(item) {
      this.$set(item, 'renameFlag', false)
      if (item.queryName) {
        this.editLoading = true
        const { data: { code, data } } = await renameChatSession(item)
        this.editLoading = false
        this.editDialog = false
      } else {
        item.queryName = this.oldQueryName
      }
    }
    ,
    async openNewChat() {
      this.$emit('openNewChat')
      this.drawer = false
    }
    ,
    appBarMenuClick() {
      this.drawer = !this.drawer
    },
    messageSearch(item) {
      this.drawer = false
      this.message = item.queryName
      if (item.chatSessionId === this.chatSessionId) {
        return
      }
      for (let i = 0; i < this.chatSessionList.length; i++) {
        const open = this.chatSessionList[i].chatSessionId === item.chatSessionId
        this.$set(this.chatSessionList[i], 'open', open)
      }
      store.commit('chat/SET_CHAT_SESSION_ID', item.chatSessionId)
      store.commit('chat/SET_MODEL_TYPE', item.modelType)
      set_conversation_id(item.conversationId)
      this.$emit('messageSearch', item)
    }
    ,
    deleteMsg(item) {
      this.deleteMsgDialog = true
      this.deleteMag = item
    }
    ,
    openEditDialog(item) {
      this.editDialog = true
      this.currentItem = item
    }
    ,
    async rename(item) {
      this.openEditDialog(item)
      this.oldQueryName = item.queryName
      this.$set(item, 'renameFlag', true)
    }
    ,
    async deleteQueryMessage() {
      this.deleteMagLoading = true
      await deleteByChatSessionId({ chatSessionId: this.deleteMag.chatSessionId })
      this.deleteMsgDialog = false
      this.deleteMagLoading = false
      this.$message.success('删除成功！')
      this.$emit('deleteQueryMessage')
    }
    ,
    mouseover(item) {
      this.$set(item, 'showOption', true)
    }
    ,
    mouseleave(item) {
      this.$set(item, 'showOption', false)
    }
    ,
  }
  ,
}
</script>
<style lang='scss' scoped>
.mobile-main-container {
  height: 100vh;
  overflow: hidden;
  border: none;
  background: linear-gradient(180deg, #f4f0fd 3%, #fff 20%);

  .chat-container {
    display: flex;
    flex-direction: column;
  }

  .start-new-chat {
    background: linear-gradient(139.44deg, #c686ff 0%, #6331c0 100%);
  }

  ::v-deep .v-list-item {
    padding: 0;
  }

  ::v-deep .v-btn:not(.v-btn--round).v-size--default {
    height: 32px !important;
    //padding: 0 10px;
    //width: 119px;
  }

  ::v-deep .v-navigation-drawer__border {
    width: 0;
  }

  .hover-item {
    background: #ebe5fa;
    width: 100%;
    border-radius: 0;
    height: 100%;
  }

  .hover-item::before {
    content: '';
    position: absolute;
    height: 45px;
    width: 4px;
    background: #a100ff;
    left: 4px;
  }

  .selected-item {
    background: #ebe5fa;
    border-radius: 0;
    height: 100%;
  }

  .selected-item::before {
    content: '';
    position: absolute;
    height: 45px;
    width: 4px;
    background: #a100ff;
    left: 4px;
  }

  .gradient-text {
    font-size: 18px;
    font-weight: bold;
    background: linear-gradient(270.00deg, #a100ff 0%, #d87ab7 100%);
    -webkit-background-clip: text;
    color: transparent;
  }

  .new-chat-btn {
    width: 264px;
    height: 48px;
    border-radius: 8px;
    background: #fff;
  }

  /* 整个滚动条 */
  ::-webkit-scrollbar {
    width: 3px; /* 垂直滚动条宽度 */
    height: 5px; /* 水平滚动条高度 */
  }

  /* 滚动条轨道 */
  ::-webkit-scrollbar-track {
    background: #f1f1f1; /* 轨道背景色 */
    border-radius: 5px; /* 圆角 */
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    background: #888; /* 滑块颜色 */
    border-radius: 5px; /* 圆角 */
    //border: 1px solid #f1f1f1; /* 滑块边框 */
  }

  /* 滚动条滑块悬停效果 */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; /* 悬停时滑块颜色 */
  }
}
</style>
